/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// About Us page sections
// import Information from "pages/LandingPages/AboutUs/sections/Information";
// import Team from "pages/LandingPages/AboutUs/sections/Team";
// import Featuring from "pages/LandingPages/AboutUs/sections/Featuring";
import AboutCompany from "pages/LandingPages/AboutUs/sections/aboutCompany";
import Newsletter from "pages/LandingPages/AboutUs/sections/Newsletter";
import Services from "pages/LandingPages/AboutUs/sections/Services";
import ContactUsSection from "pages/LandingPages/AboutUs/sections/contactUs";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import constructionSite from "assets/images/screeding.png";
import cuttingImage from "assets/images/Image_showing_concrete_diamond_cutting.jpeg";
import modernInterior from "assets/images/site_cleaning.jpg";

function AboutUs() {
  // List of background images to switch between
  const bgImages = [constructionSite, cuttingImage, modernInterior];

  const [activeIndex, setActiveIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const fadeDuration = 500;
  const activeBg = bgImages[activeIndex];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsFading(true);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!isFading) return undefined;

    const timeoutId = setTimeout(() => {
      setActiveIndex((prev) => (prev + 1) % bgImages.length);
      setIsFading(false);
    }, fadeDuration);

    return () => clearTimeout(timeoutId);
  }, [isFading, bgImages.length, fadeDuration]);

  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "internal",
          route: "/pages/landing-pages/contact-us",
          label: "Contact Us",
          color: "default",
        }}
        transparent
        light
      />
      <MKBox
        minHeight="75vh"
        width="100%"
        position="relative"
        overflow="hidden"
        display="grid"
        placeItems="center"
      >
        <MKBox
          aria-hidden
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          sx={({ functions: { linearGradient, rgba }, palette: { gradients } }) => ({
            backgroundImage: `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${activeBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          })}
        />
        <Container
          sx={{
            height: "80%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center", position: "relative", zIndex: 1 }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Construction Site Services.
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
              We are fully accredited contractors delivering projects across the UK.
            </MKTypography>
            <MKButton
              color="default"
              sx={{ color: ({ palette: { dark } }) => dark.main }}
              component="a"
              href="#contact-us"
            >
              Talk to an expert
            </MKButton>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 0,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <AboutCompany />
        <Services />
      </Card>
      <MKBox
        minHeight="50vh"
        width="100%"
        mrginBottom="50px"
        position="relative"
        overflow="hidden"
        display="grid"
        placeItems="center"
      >
        <MKBox
          aria-hidden
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          sx={({ functions: { linearGradient, rgba }, palette: { gradients } }) => ({
            backgroundImage: `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${activeBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            transition: `opacity ${fadeDuration}ms ease-in-out`,
            opacity: isFading ? 0 : 1,
          })}
        />
        <Container
          sx={{
            height: "80%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center", position: "relative", zIndex: 1 }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Ready to work with us?
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
              Take the first step and contact us, We will guide you every step of the way.
            </MKTypography>
            <MKButton
              color="default"
              sx={{ color: ({ palette: { dark } }) => dark.main }}
              component={Link}
              to="/pages/landing-pages/contact-us"
            >
              Contact Us
            </MKButton>
          </Grid>
        </Container>
      </MKBox>
      <Card
        id="contact-us"
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <ContactUsSection />
      </Card>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Newsletter />
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default AboutUs;
